import { Turbo } from "@hotwired/turbo-rails"

// Custom <turbo-stream action="visit" url="…">
// Sends the page to `url` with a Turbo visit. Only same-origin urls are followed.
Turbo.StreamActions.visit = function () {
  const url = this.getAttribute("url")
  if (!url || new URL(url, window.location.origin).origin !== window.location.origin) return

  Turbo.visit(url)
}
